<template>
  <div class="container-fluid">
    <div class="row">
      <product-list />
    </div>
  </div>
</template>

<script>
import ProductList from "./ProductList";

export default {
  components: { ProductList }
};
</script>
